import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { api } from "@/config/api";
import { queryKeys } from "@/hooks/queries";
import type { AnswerResult, ApiResponse, Scenario } from "@/types";

interface DailyChallengeApiResponse extends ApiResponse {
  dailyChallenge: Scenario & {
    communityStats: { totalAttempts: number; totalCorrect: number };
    alreadyAnswered: boolean;
  };
}

interface DailyChallengeAnswerApiResponse extends ApiResponse {
  result: AnswerResult;
  communityStats: { totalAttempts: number; totalCorrect: number };
}

export function useDailyChallenge() {
  return useQuery({
    queryKey: queryKeys.dailyChallenge,
    queryFn: () => api.get<DailyChallengeApiResponse>("/api/daily-challenge"),
    select: (data) => data.dailyChallenge,
  });
}

export function useSubmitDailyChallenge() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ selectedOptionId }: { selectedOptionId: string }) =>
      api.post<DailyChallengeAnswerApiResponse>("/api/daily-challenge/answer", {
        selectedOptionId,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.stats });
      queryClient.invalidateQueries({ queryKey: queryKeys.progress });
      queryClient.invalidateQueries({ queryKey: queryKeys.achievements });
      queryClient.invalidateQueries({ queryKey: queryKeys.dailyChallenge });
      queryClient.invalidateQueries({ queryKey: queryKeys.leaderboard });
    },
  });
}
